(function () {
  function boot() {
    document.querySelectorAll("[data-star-universe]").forEach(initStarUniverse);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  function initStarUniverse(root) {
    const canvas = root.querySelector(".star-universe-canvas");
    const ctx = canvas.getContext("2d");
    const form = root.querySelector(".star-universe-form");
    const tooltip = root.querySelector(".star-universe-tooltip");
    const message = root.querySelector(".star-universe-message");
    const colorPicker = form.querySelector('[name="star_color_picker"]');
    const colorHex = form.querySelector('[name="star_color_hex"]');
    

    const sectionId = root.dataset.sectionId || "default";
    const apiBase = cleanApiBase(root.dataset.apiBase || "");
    const demoStarsCount = parseInt(root.dataset.demoStars || "45", 10);

    const STAR_ID_KEY = "starUniverse.starId." + sectionId;
    const LOCAL_STARS_KEY = "starUniverse.localStars." + sectionId;

    const state = {
  stars: [],
  myStarId: localStorage.getItem(STAR_ID_KEY) || "",
  width: 0,
  height: 0,
  dpr: 1,
  pointerX: -9999,
  pointerY: -9999,
  hovered: null,
  selectedStarId: "",
  tooltipX: 0,
  tooltipY: 0,
  tooltipReady: false,
  lastTime: performance.now()
};

    syncColorInputs();
    resize();
    bindEvents();
    loadStars().then(function () {
      requestAnimationFrame(tick);
    });

    function bindEvents() {
  window.addEventListener("resize", function () {
    resize();
    state.tooltipReady = false;
  });

  colorPicker.addEventListener("input", function () {
    colorHex.value = normalizeHex(colorPicker.value);
  });

  colorHex.addEventListener("input", function () {
    const value = normalizeHex(colorHex.value);
    colorHex.value = value;
    if (isValidHex(value)) colorPicker.value = value;
  });

  root.addEventListener("pointermove", function (event) {
    if (isInsidePanel(event.target)) return;

    const rect = canvas.getBoundingClientRect();
    state.pointerX = event.clientX - rect.left;
    state.pointerY = event.clientY - rect.top;
  });

  root.addEventListener("pointerdown", function (event) {
    if (!isMobileStarMode()) return;
    if (isInsidePanel(event.target)) return;

    const rect = canvas.getBoundingClientRect();
    const tapX = event.clientX - rect.left;
    const tapY = event.clientY - rect.top;

    const nearest = findNearestStar(tapX, tapY, 42);

    if (nearest) {
      state.selectedStarId = nearest.id;
      state.hovered = nearest;
      state.tooltipReady = false;

      renderTooltipContent(nearest);
      tooltip.hidden = false;

      event.preventDefault();
      return;
    }

    state.selectedStarId = "";
    state.hovered = null;
    state.tooltipReady = false;
    tooltip.hidden = true;
  });

  root.addEventListener("pointerleave", function () {
    state.pointerX = -9999;
    state.pointerY = -9999;
    state.hovered = null;

    if (!state.selectedStarId) {
      tooltip.hidden = true;
    }
  });

  window.addEventListener(
    "scroll",
    function () {
      if (state.selectedStarId) {
        state.tooltipReady = false;
      }
    },
    { passive: true }
  );

  form.addEventListener("submit", submitStar);
}

    function syncColorInputs() {
      const fallback = "#7A6BFF";
      const initial = isValidHex(colorHex.value) ? normalizeHex(colorHex.value) : fallback;
      colorHex.value = initial;
      colorPicker.value = initial;
    }

    function resize() {
  const viewport = window.visualViewport;

  state.dpr = Math.min(window.devicePixelRatio || 1, 2);
  state.width = Math.floor(viewport ? viewport.width : window.innerWidth);
  state.height = Math.floor(viewport ? viewport.height : window.innerHeight);

  canvas.width = Math.floor(state.width * state.dpr);
  canvas.height = Math.floor(state.height * state.dpr);

  canvas.style.width = state.width + "px";
  canvas.style.height = state.height + "px";

  ctx.setTransform(state.dpr, 0, 0, state.dpr, 0, 0);
}

    // REPLACE your loadStars() function with this:

async function loadStars() {
  setMessage("Loading the universe...", "");

  if (apiBase) {
    try {
      const url = apiBase + "/stars?self=" + encodeURIComponent(state.myStarId || "");
      const response = await fetch(url, {
        method: "GET",
        headers: { "Accept": "application/json" }
      });

      if (!response.ok) throw new Error("Could not load stars.");

      const data = await response.json();
      state.stars = normalizeStars(data.stars || []);

      if (data.myStarId) {
        state.myStarId = data.myStarId;
        localStorage.setItem(STAR_ID_KEY, data.myStarId);
      }

      if (state.myStarId) {
        setMessage("Your star is already in the universe. You are here.", "is-success");
      } else {
        setMessage("", "");
      }

      return;
    } catch (error) {
      setMessage("Live universe unavailable. Showing local stars for now.", "is-error");
    }
  }

  state.stars = getLocalStars();

  if (state.myStarId) {
    setMessage("Your star is already in the universe. You are here.", "is-success");
  } else {
    setMessage("", "");
  }
}

async function submitStar(event) {
  if (form.dataset.shopifySubmitting === "true") {
    return;
  }

  event.preventDefault();

  const submitButton = form.querySelector(".star-universe-submit");
  const formData = new FormData(form);

  const displayName = sanitizeText(formData.get("display_name"), 32);
  const socialHandle = sanitizeHandle(formData.get("social_handle"), 40);
  const email = sanitizeEmail(formData.get("contact[email]"));
  const publicLocation = sanitizeText(formData.get("public_location"), 50);
  const color = normalizeHex(formData.get("star_color_hex"));
  const consent = formData.get("consent") === "on";

  if (!displayName || !socialHandle || !email || !isValidHex(color) || !consent) {
    setMessage("Fill out every required field and choose a valid color.", "is-error");
    return;
  }

  const payload = {
    display_name: displayName,
    social_handle: socialHandle,
    email: email,
    public_location: publicLocation,
    star_color: color,
    consent: true,
    source: "shopify-password-page"
  };

  submitButton.disabled = true;

  try {
    if (state.myStarId && !apiBase) {
      setMessage("Your email was sent to Shopify. Your star is already here.", "is-success");

      submitShopifyCustomerForm();

      setTimeout(function () {
        submitButton.disabled = false;
      }, 1600);

      return;
    }

    if (apiBase) {
      const response = await fetch(apiBase + "/stars", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json().catch(function () {
        return {};
      });

      if (response.status === 409) {
        setMessage("Your email was sent to Shopify. This network already has a star.", "is-success");

        submitShopifyCustomerForm();

        setTimeout(function () {
          submitButton.disabled = false;
        }, 1600);

        return;
      }

      if (!response.ok) {
        throw new Error(data.message || "Could not create your star.");
      }

      if (data.star && data.star.id) {
        state.myStarId = data.star.id;
        localStorage.setItem(STAR_ID_KEY, state.myStarId);
      }

      if (Array.isArray(data.stars)) {
        state.stars = normalizeStars(data.stars);
      } else if (data.star) {
        upsertStar(normalizeStar(data.star));
      }

      setMessage("Your star has entered the universe. You are here.", "is-success");

      submitShopifyCustomerForm();

      setTimeout(function () {
        form.reset();
        colorHex.value = color;
        colorPicker.value = color;
        submitButton.disabled = false;
      }, 1600);

      return;
    }

    const newStar = createLocalStar(payload);
    state.myStarId = newStar.id;
    localStorage.setItem(STAR_ID_KEY, state.myStarId);
    upsertStar(newStar);
    saveLocalStars(state.stars);

    setMessage("Your star has entered the universe. You are here.", "is-success");

    submitShopifyCustomerForm();

    setTimeout(function () {
      form.reset();
      colorHex.value = color;
      colorPicker.value = color;
      submitButton.disabled = false;
    }, 1600);
  } catch (error) {
    setMessage(error.message || "Something went wrong.", "is-error");
    submitButton.disabled = false;
  }
}

function submitShopifyCustomerForm() {
  const submitButton = form.querySelector(".star-universe-submit");

  form.dataset.shopifySubmitting = "true";

  if (submitButton) {
    submitButton.disabled = false;
  }

  setTimeout(function () {
    if (typeof form.requestSubmit === "function" && submitButton) {
      form.requestSubmit(submitButton);
    } else {
      HTMLFormElement.prototype.submit.call(form);
    }

    setTimeout(function () {
      form.dataset.shopifySubmitting = "false";
    }, 1500);
  }, 900);
}

    function tick(now) {
  const dt = Math.min(0.05, (now - state.lastTime) / 1000);
  state.lastTime = now;

  moveStars(dt);
  draw();
  updateStarTooltip();

  requestAnimationFrame(tick);
}

    function moveStars(dt) {
  for (let i = 0; i < state.stars.length; i++) {
    const star = state.stars[i];

    star.x += star.vx * dt;
    star.y += star.vy * dt;

    const radius = star.id === state.myStarId
      ? (star.radius || 2.2) + 14
      : (star.radius || 2.2) + 4;

    const minX = radius / state.width;
    const maxX = 1 - radius / state.width;
    const minY = radius / state.height;
    const maxY = 1 - radius / state.height;

    if (star.x < minX) {
      star.x = minX;
      star.vx = Math.abs(star.vx);
    }

    if (star.x > maxX) {
      star.x = maxX;
      star.vx = -Math.abs(star.vx);
    }

    if (star.y < minY) {
      star.y = minY;
      star.vy = Math.abs(star.vy);
    }

    if (star.y > maxY) {
      star.y = maxY;
      star.vy = -Math.abs(star.vy);
    }
  }
}

    function draw() {
      ctx.clearRect(0, 0, state.width, state.height);

      drawDust();

      for (let i = 0; i < state.stars.length; i++) {
        drawStar(state.stars[i]);
      }
    }

    function drawDust() {
      ctx.save();
      ctx.globalAlpha = 0.28;

      for (let i = 0; i < 80; i++) {
        const x = seededNoise(i * 12.9898) * state.width;
        const y = seededNoise(i * 78.233) * state.height;
        const radius = seededNoise(i * 4.611) * 1.2 + 0.15;

        ctx.beginPath();
        ctx.arc(x, y, radius, 0, Math.PI * 2);
        ctx.fillStyle = "rgba(255,255,255,0.55)";
        ctx.fill();
      }

      ctx.restore();
    }

    function drawStar(star) {
  const x = star.x * state.width;
  const y = star.y * state.height;
  const radius = star.radius || 2.2;
  const isMine = star.id === state.myStarId;
  const isSelected = star.id === state.selectedStarId;
  const pulse = isSelected ? Math.sin(performance.now() / 420) * 0.5 + 0.5 : 0;

  const glowRadius = isMine ? 36 : isSelected ? 34 + pulse * 6 : 24;

  const glow = ctx.createRadialGradient(x, y, 0, x, y, glowRadius);
  glow.addColorStop(0, hexToRgba(star.star_color, isMine || isSelected ? 0.95 : 0.72));
  glow.addColorStop(0.28, hexToRgba(star.star_color, isMine || isSelected ? 0.34 : 0.18));
  glow.addColorStop(1, hexToRgba(star.star_color, 0));

  ctx.save();

  ctx.fillStyle = glow;
  ctx.beginPath();
  ctx.arc(x, y, glowRadius, 0, Math.PI * 2);
  ctx.fill();

  ctx.fillStyle = star.star_color;
  ctx.beginPath();
  ctx.arc(x, y, isMine || isSelected ? radius + 1.2 : radius, 0, Math.PI * 2);
  ctx.fill();

  ctx.fillStyle = "rgba(255,255,255,0.92)";
  ctx.beginPath();
  ctx.arc(x - radius * 0.28, y - radius * 0.28, Math.max(0.6, radius * 0.28), 0, Math.PI * 2);
  ctx.fill();

  if (isMine || isSelected) {
    ctx.strokeStyle = isMine
      ? "rgba(236, 236, 236, 0.78)"
      : "rgba(214, 214, 214, 0.58)";

    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.arc(x, y, isMine ? 13 : 12 + pulse * 5, 0, Math.PI * 2);
    ctx.stroke();
  }

  if (isMine) {
    ctx.font = "10px Arial, sans-serif";
    ctx.textAlign = "center";
    ctx.fillStyle = "rgba(39, 39, 39, 0.88)";
    ctx.fillText("YOU ARE HERE", x, y - 22);
  }

  ctx.restore();
}

    function updateStarTooltip() {
  if (state.selectedStarId) {
    const selected = state.stars.find(function (star) {
      return star.id === state.selectedStarId;
    });

    if (!selected) {
      state.selectedStarId = "";
      state.hovered = null;
      tooltip.hidden = true;
      return;
    }

    state.hovered = selected;
    renderTooltipContent(selected);
    positionTooltipNearStar(selected, true);
    return;
  }

  if (isMobileStarMode()) {
    tooltip.hidden = true;
    return;
  }

  const nearest = findNearestStar(state.pointerX, state.pointerY, 18);
  state.hovered = nearest;

  if (!nearest) {
    tooltip.hidden = true;
    return;
  }

  renderTooltipContent(nearest);

  tooltip.hidden = false;
  tooltip.style.left = state.pointerX + "px";
  tooltip.style.top = state.pointerY + "px";
}

function findNearestStar(x, y, hitRadius) {
  let nearest = null;
  let nearestDistance = Infinity;

  for (let i = 0; i < state.stars.length; i++) {
    const star = state.stars[i];
    const starX = star.x * state.width;
    const starY = star.y * state.height;
    const dx = starX - x;
    const dy = starY - y;
    const distance = Math.sqrt(dx * dx + dy * dy);

    if (distance < hitRadius && distance < nearestDistance) {
      nearest = star;
      nearestDistance = distance;
    }
  }

  return nearest;
}

function positionTooltipNearStar(star, softFollow) {
  const starX = star.x * state.width;
  const starY = star.y * state.height;

  tooltip.hidden = false;

  const tooltipWidth = tooltip.offsetWidth || 170;
  const tooltipHeight = tooltip.offsetHeight || 80;

  let targetX = starX + 16;
  let targetY = starY + 16;

  targetX = clampNumber(targetX, 10, state.width - tooltipWidth - 10, 10);
  targetY = clampNumber(targetY, 10, state.height - tooltipHeight - 10, 10);

  if (!state.tooltipReady || !softFollow) {
    state.tooltipX = targetX;
    state.tooltipY = targetY;
    state.tooltipReady = true;
  } else {
    state.tooltipX += (targetX - state.tooltipX) * 0.13;
    state.tooltipY += (targetY - state.tooltipY) * 0.13;
  }

  tooltip.style.left = state.tooltipX + "px";
  tooltip.style.top = state.tooltipY + "px";
}

function renderTooltipContent(star) {
  const signature = [
    star.id,
    star.display_name,
    star.social_handle,
    star.public_location,
    star.id === state.myStarId,
    star.id === state.selectedStarId
  ].join("|");

  if (tooltip.dataset.signature === signature) return;

  tooltip.dataset.signature = signature;
  tooltip.innerHTML = "";

  const name = document.createElement("strong");
  name.textContent = star.display_name || "Unknown Star";

  const social = document.createElement("span");
  social.textContent = star.social_handle || "";

  const location = document.createElement("span");
  location.textContent = star.public_location || "";

  tooltip.appendChild(name);

  if (social.textContent) {
    tooltip.appendChild(social);
  }

  if (location.textContent) {
    tooltip.appendChild(location);
  }

  if (star.id === state.myStarId) {
    const here = document.createElement("em");
    here.textContent = "You are here";
    tooltip.appendChild(here);
  } else if (star.id === state.selectedStarId && isMobileStarMode()) {
    const locked = document.createElement("em");
    locked.textContent = "Signal found";
    tooltip.appendChild(locked);
  }
}

function isMobileStarMode() {
  return window.matchMedia("(hover: none), (pointer: coarse)").matches;
}

function isInsidePanel(target) {
  return Boolean(
    target &&
    typeof target.closest === "function" &&
    target.closest(
      ".star-universe-panel, .star-universe-form-toggle, .star-universe-center-nav"
    )
  );
}

    function getLocalStars() {
      const saved = readJson(LOCAL_STARS_KEY, []);
      const demo = createDemoStars(demoStarsCount);
      const merged = demo.concat(saved);
      return normalizeStars(merged);
    }

    function saveLocalStars(stars) {
      const customStars = stars.filter(function (star) {
        return String(star.id).indexOf("demo-") !== 0;
      });

      localStorage.setItem(LOCAL_STARS_KEY, JSON.stringify(customStars));
    }

    function createLocalStar(payload) {
      return normalizeStar({
        id: createId(),
        display_name: payload.display_name,
        social_handle: payload.social_handle,
        public_location: payload.public_location,
        star_color: payload.star_color,
        x: randomBetween(0.14, 0.86),
        y: randomBetween(0.16, 0.84),
        vx: randomVelocity(),
        vy: randomVelocity(),
        radius: randomBetween(2.1, 3.2),
        created_at: new Date().toISOString()
      });
    }

    function createDemoStars(count) {
      const names = [
        "VOIDKID", "LUNA", "ORBIT", "SAINT", "NEBULA", "ZERO", "ASTRA", "NOVA",
        "ECHO", "HALO", "MARS", "VENUS", "PLUTO", "SOL", "COSMO", "VANTA"
      ];

      const colors = [
        "#FFFFFF", "#7A6BFF", "#FF4FD8", "#47E7FF", "#FFB84D", "#9BFF7A",
        "#FF6B6B", "#B18CFF", "#E7FF5C", "#6BFFDE"
      ];

      const stars = [];

      for (let i = 0; i < count; i++) {
        stars.push(normalizeStar({
          id: "demo-" + i,
          display_name: names[i % names.length],
          social_handle: "@signal" + String(i + 1).padStart(2, "0"),
          public_location: i % 3 === 0 ? "Earth" : "",
          star_color: colors[i % colors.length],
          x: 0.06 + seededNoise(i * 18.9) * 0.88,
          y: 0.08 + seededNoise(i * 41.7) * 0.84,
          vx: seededSigned(i * 2.17) * 0.018,
          vy: seededSigned(i * 8.42) * 0.018,
          radius: 1.8 + seededNoise(i * 6.31) * 1.6,
          created_at: new Date(Date.now() - i * 1000000).toISOString()
        }));
      }

      return stars;
    }

    function upsertStar(star) {
      if (!star || !star.id) return;

      const index = state.stars.findIndex(function (existing) {
        return existing.id === star.id;
      });

      if (index >= 0) {
        state.stars[index] = star;
      } else {
        state.stars.push(star);
      }
    }

    function normalizeStars(stars) {
      return stars.map(normalizeStar).filter(Boolean);
    }

    function normalizeStar(star) {
      if (!star) return null;

      const color = isValidHex(star.star_color) ? normalizeHex(star.star_color) : "#FFFFFF";

      return {
        id: String(star.id || createId()),
        display_name: sanitizeText(star.display_name || star.name || "Unknown Star", 32),
        social_handle: sanitizeHandle(star.social_handle || star.social || "", 40),
        public_location: sanitizeText(star.public_location || star.location || "", 50),
        star_color: color,
        x: clampNumber(Number(star.x), 0.02, 0.98, randomBetween(0.08, 0.92)),
        y: clampNumber(Number(star.y), 0.04, 0.96, randomBetween(0.08, 0.92)),
        vx: clampNumber(Number(star.vx), -0.045, 0.045, randomVelocity()),
        vy: clampNumber(Number(star.vy), -0.045, 0.045, randomVelocity()),
        radius: clampNumber(Number(star.radius), 1.4, 4.5, randomBetween(1.9, 3.1)),
        created_at: star.created_at || new Date().toISOString()
      };
    }

    function setMessage(text, className) {
  if (!message) return;

  message.textContent = text || "";
  message.className = "star-universe-message";

  if (className) {
    message.classList.add(className);
  }

  if (text) {
    message.style.display = "block";
  } else {
    message.style.display = "";
  }
}
  }

  function cleanApiBase(value) {
    return String(value || "").trim().replace(/\/$/, "");
  }

  function normalizeHex(value) {
    value = String(value || "").trim();

    if (!value.startsWith("#")) value = "#" + value;

    if (value.length > 7) value = value.slice(0, 7);

    return value.toUpperCase();
  }

  function isValidHex(value) {
    return /^#[0-9A-F]{6}$/i.test(String(value || "").trim());
  }

  function sanitizeText(value, maxLength) {
    return String(value || "")
      .replace(/[<>]/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, maxLength);
  }

  function sanitizeHandle(value, maxLength) {
    value = sanitizeText(value, maxLength);
    if (!value) return "";
    if (value[0] !== "@") value = "@" + value;
    return value;
  }

  function sanitizeEmail(value) {
    return String(value || "").trim().slice(0, 80);
  }

  function clampNumber(value, min, max, fallback) {
    if (!Number.isFinite(value)) return fallback;
    return Math.max(min, Math.min(max, value));
  }

  function randomBetween(min, max) {
    return min + Math.random() * (max - min);
  }

  function randomVelocity() {
    const speed = randomBetween(0.008, 0.022);
    return Math.random() > 0.5 ? speed : -speed;
  }

  function seededNoise(seed) {
    const x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
  }

  function seededSigned(seed) {
    return seededNoise(seed) * 2 - 1;
  }

  function hexToRgba(hex, alpha) {
    const normalized = normalizeHex(hex);
    const r = parseInt(normalized.slice(1, 3), 16);
    const g = parseInt(normalized.slice(3, 5), 16);
    const b = parseInt(normalized.slice(5, 7), 16);
    return "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
  }

  function createId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }

    return "star-" + Date.now() + "-" + Math.random().toString(16).slice(2);
  }

  function readJson(key, fallback) {
    try {
      const value = localStorage.getItem(key);
      return value ? JSON.parse(value) : fallback;
    } catch (error) {
      return fallback;
    }
  }
})();
(function () {
  function bootMobileFormToggle() {
    document.querySelectorAll("[data-star-universe]").forEach(function (root) {
      const toggle = root.querySelector("[data-form-toggle]");

      if (!toggle) return;

      toggle.addEventListener("click", function () {
        const isOpen = root.classList.toggle("is-form-open");
        toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootMobileFormToggle);
  } else {
    bootMobileFormToggle();
  }
})();